<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <h2 class="members__headline">{{ word_chg('お問い合わせH') }}</h2>
        <div class="members-inquiry">
          <div class="members-inquiry__wrapper">
            <div class="members-inquiry__name">
              <p>
                <label for="subject_name">{{ word_chg('件名') }}</label>
              </p>
            </div>
            <div class="members-inquiry__data">
                <div class="top__reserveOptionInput" style="width: 100%;">
                  <bs-select
                    :name="'subject'"
                    :options="inquiry_subject_list"
                    v-model="inquiry_subject"
                    :null-option="true"
                    class="top__reserveOptionSelect"
                  ></bs-select>
                  </div>
            </div>
          </div>
          <div class="members-inquiry__wrapper">
            <div class="members-inquiry__name">
              <p>
                <label for="person_name">{{ word_chg('お名前') }}</label>
              </p>
            </div>
            <div class="members-inquiry__data">
              <input type="text" v-model="inquiry_name" placeholder="">
            </div>
          </div>
          <div class="members-inquiry__wrapper">
            <div class="members-inquiry__name">
              <p>
                <label for="email_name">{{ word_chg('返信先') }}</label>
              </p>
            </div>
            <div class="members-inquiry__data">
              <input type="email" v-model="inquiry_email" placeholder="">
            </div>
          </div>
          <div class="members-inquiry__wrapper">
            <div class="members-inquiry__name">
              <p>
                <label for="message_body">{{ word_chg('内容') }}</label>
              </p>
            </div>
            <div class="members-inquiry__data">
              <textarea v-model="inquiry_body" cols="50" rows="5" placeholder=""></textarea>
            </div>
          </div>
          <p class="members-inquiry__confirm" v-if="disabledCheck">
            {{ word_chg('お問い合わせ項目を全て入力してください。') }}
          </p>
          <p class="members-inquiry__confirm" v-else>
            <button @click="send()">{{ word_chg('送信する') }}</button>
          </p>
        </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import BsSelect from '../../atoms/BsSelect.vue'
export default {
    name: 'BsInquiryIndexView',
    data: function () {
        return {
          inquiry_subject: '',
          inquiry_name: '',
          inquiry_email: '',
          inquiry_body: '',
        }
    },
    props: {
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        BsSelect,
    },
    methods: {
      send(){
        const param = {};
        param['m_id'] = this.$store.state.auth.userId;
        param['m_number'] = this.getMyNumber;
        param['subject'] = this.inquiry_subject;
        param['m_label'] = this.inquiry_name;
        param['reply'] = this.inquiry_email;
        param['body'] = this.inquiry_body;

        return this.$store.dispatch('updateBasic', {data: param, target: 'inquiry'})
          .then((response) => {
            if(typeof response === 'object' && response.data ){
              alert('送信しました');
            }
          })
          .catch(
            () => {
              // err => Promise.reject(err);
                alert('送信できませんでした');
              }
          )
          .finally(() => {
            // this.$router.go({ path: '/user/index' })
          });
      },
    },
    created () {
      this.inquiry_name = this.getMyName;
      this.inquiry_email = this.getEmail;
    },
    computed: {
      ...mapState({
        user: state => state.apidata.user,
        set_lang: state => state.apidata.set_lang,
      }),
      disabledCheck: function(){
        if(
          this.inquiry_subject == '' 
          || this.inquiry_name == '' 
          || this.inquiry_email == ''
        ){
          return true;
        }
        return false;
      },
      getMyData: function(){
        const mydata = this.user.find((data) => {
          return data.id == this.$store.state.auth.userId;
        })
        return mydata;
      },
      getMyNumber: function(){
        let myNumber = '';
        if(this.getMyData.number) myNumber += this.getMyData.number;
        return myNumber;
      },
      getMyName: function(){
        let myName = '';
        if(this.getMyData.name_1) myName += this.getMyData.name_1;
        if(this.getMyData.name_2) myName += this.getMyData.name_2;
        if(this.getMyData.name_3) myName += this.getMyData.name_3;
        return myName;
      },
      getEmail: function(){
        let Email = '';
        if(this.getMyData.login_id) Email += this.getMyData.login_id;
        return Email;
      },
      inquiry_subject_list: function(){
        const list = [
          this.word_chg('走行予約について'),
          this.word_chg('宿泊・施設について'),
          this.word_chg('その他')
        ];
        const tmps = [];
        list.forEach((l) => {
          tmps.push({
            key: l,
            label: l
          })
        });
        return tmps;
      },
    }
}
</script>
